import { __assign, __read } from "tslib";
import { map, size } from 'lodash-es';
import React, { useRef, useState } from 'react';
import { useOnClickOutside } from '@marvelapp/hooks';
import { Badge, Box, Button, Flex, Heading, Link, Popover, Position, Text, } from '@marvelapp/ui';
import { SpecsBorderItem } from '@marvelapp/ui-internal';
import AssetPreview from '../AssetPreview';
import { CaretIcon } from '../icons';
var formatToType = {
    svg: {
        label: 'vector',
        color: 'yellow',
    },
    png: {
        label: 'image',
        color: 'purple',
    },
    jpg: {
        label: 'image',
        color: 'green',
    },
    pdf: {
        label: 'document',
        color: 'red',
    },
    tiff: {
        label: 'image',
        color: 'orange',
    },
    webp: {
        label: 'image',
        color: 'orange',
    },
    eps: {
        label: 'vector',
        color: 'yellow',
    },
};
export default function ElementAssets(_a) {
    var assets = _a.assets, assetWidth = _a.assetWidth, bestAssetUrl = _a.bestAssetUrl, downloadAll = _a.downloadAll, downloadType = _a.downloadType, hasDownloadedAll = _a.hasDownloadedAll, hasDownloadedType = _a.hasDownloadedType, isDownloadingAll = _a.isDownloadingAll, isDownloadingType = _a.isDownloadingType, name = _a.name;
    var ref = useRef();
    var assetsSize = size(assets);
    var hasMoreThanOneAsset = assetsSize > 1;
    var _b = __read(useState(false), 2), isPopoverOpen = _b[0], setIsPopoverOpen = _b[1];
    var togglePopover = function () {
        setIsPopoverOpen(!isPopoverOpen);
    };
    useOnClickOutside(ref, function () {
        setIsPopoverOpen(false);
    });
    return (React.createElement(SpecsBorderItem, { marginBottom: 3, paddingBottom: 3 },
        React.createElement(Box, { width: assetWidth },
            React.createElement(AssetPreview, { url: bestAssetUrl })),
        React.createElement(Flex, { alignItems: "flex-start", flex: 1, justifyContent: "space-between", paddingLeft: 12 },
            React.createElement(Flex, { alignItems: "center", minHeight: assetWidth },
                React.createElement(Box, { paddingRight: 2 },
                    React.createElement(Heading, { fontSize: 2, fontWeight: 500, marginBottom: 1, wrap: true }, name),
                    React.createElement(Text, { fontSize: 12 },
                        assetsSize,
                        " asset",
                        hasMoreThanOneAsset ? 's' : null))),
            React.createElement(Flex, { alignItems: "center", height: assetWidth },
                React.createElement(Position, { ref: ref },
                    React.createElement(Button, { hasSucceeded: hasDownloadedAll(), height: 28, isLoading: isDownloadingAll(), kind: "ghost", paddingLeft: "1px", paddingRight: "1px", translateOnHover: false },
                        React.createElement(Flex, { alignItems: "center" },
                            React.createElement(Flex, { alignItems: "center", borderRadius: "15px 0 0 15px", fontSize: 11, height: 26, hoverBg: "snowDark", onClick: downloadAll, paddingLeft: 16, paddingRight: 10 }, "Download"),
                            React.createElement(Flex, { alignItems: "center", borderLeft: "1px solid", 
                                // eslint-disable-next-line
                                borderColor: isDownloadingAll() || hasDownloadedAll()
                                    ? 'transparent'
                                    : 'smoke', borderRadius: "0 15px 15px 0", "data-testid": "toggle-download-all-assets", height: 26, hoverBg: "snowDark", justifyContent: "center", onClick: togglePopover, paddingRight: "2px", width: 32 },
                                React.createElement(Box, { transform: isPopoverOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: "smooth.fast" },
                                    React.createElement(CaretIcon, { width: "6px" }))))),
                    React.createElement(Position, { zIndex: 100 },
                        React.createElement(Popover, { align: "right", boxShadow: "popover.raised", isActive: isPopoverOpen, position: "bottom", showOn: "custom", width: 240 },
                            React.createElement(Box, { padding: 10 }, map(assets, function (groupedAssets, format) {
                                return format === 'UNKNOWN' ? (React.createElement(Flex, { alignItems: "center", "data-testid": "element-asset", justifyContent: "space-between" },
                                    React.createElement(Text, { fontSize: 12 }, "Uknknown asset"),
                                    React.createElement(Link, __assign({ fontSize: 12, isLoading: isDownloadingType(format), kind: "marvel" }, downloadLinkProps(downloadType, groupedAssets, format)),
                                        React.createElement(DownloadText, { hasSucceeded: hasDownloadedType(format), isLoading: isDownloadingType(format) })))) : (formatToType[format] && (React.createElement(SpecsBorderItem, { alignItems: "center", "data-testid": "element-asset", justifyContent: "space-between", marginBottom: 10, paddingBottom: 10 },
                                    React.createElement(Flex, { alignItems: "center" },
                                        React.createElement(Badge, { kind: "ghost", marginRight: 2 }, format.toUpperCase()),
                                        React.createElement(Text, { fontSize: 12 },
                                            groupedAssets.length,
                                            ' ',
                                            formatToType[format].label,
                                            groupedAssets.length > 1 ? 's' : '')),
                                    React.createElement(Link, __assign({ fontSize: 12, fontWeight: 500, kind: "marvel" }, downloadLinkProps(downloadType, groupedAssets, format)),
                                        React.createElement(DownloadText, { hasSucceeded: hasDownloadedType(format), isLoading: isDownloadingType(format) })))));
                            })))))))));
}
function DownloadText(_a) {
    var isLoading = _a.isLoading;
    if (isLoading) {
        return 'Downloading...';
    }
    return 'Download';
}
function downloadLinkProps(downloadType, assets, format) {
    if (assets.length > 1) {
        return {
            onClick: function () {
                downloadType(format);
            },
        };
    }
    return {
        download: true,
        href: assets[0].url,
    };
}
